module.exports = __webpack_public_path__ + "img/google-logo.8f9327db.png";